import { constructionAsset, constructionEquipment, constructionSafety } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '교통은 도시 생활에서 필수적인 부분이지만, 교통 체증, 사고, 환경 오염과 같은 많은 문제를 일으키기도 합니다. 이러한 문제를 해결하기 위해 스마트 교통이 등장하여 전 세계적인 추세가 되었습니다. 그렇다면 스마트 교통이란 무엇인가? 이것이 우리의 이동 방식을 어떻게 변화시키는가? 함께 알아보겠습니다!',
  keywords: '스마트 교통, 스마트 교통 시스템, RTLS, 교통 안전, 도시 교통 솔루션',
  ogSite: '스마트 교통이란 무엇인가?',
  title: '스마트 교통이란 무엇인가?',
  ogUrl: 'https://orbro.io/blog/smartTransportation',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_GinSfhSyq5yHiaxVzt8tG7b29yjvJdkMxs4KT_TJNFB8d31jHJTfX9QHc0zbU1fHVSmlTYASkT412fDnma3d2K6FLNcNCL1Hg-2uSGeAuG1cFoGM1YB1tt3Oxs5BFJ4hMoanTUzj7l475iN-tpJ5H-2VmCmHSMDJLue-dkWBqisSaqI588drvVucrnMIjyzX1X955hlG4DErewemZKgB5B4wkO0LVzDnyNCFWxHXP9YvRV4lnpulQ1DUdHfMI5t5gycMH4-l4ZMrUCNWPZIBaPM_DGlaYHhYSAla88WXvLrJnqpk-dNSSISqFSoQA5OM-LiQ0vdzAp1jr1b7gy1ZBpkRSrOw3XruXrIbthBN7h23T0orcYUe8UFzZs1Fatjfrr46SguQcxe2fGIXJPR-0nE3qzPn5Qj5lOqGyeC-3aKLqGfbjefgRaFgYSideLf6KPewUF3cngSf4sSNG-GMjeTsP6eYnDAghkAjE6AVrMlwEVBb1rOaxvnb6s3vEghSf-x1H8NIoOlWvpMaPxl2jzHXss2dVKgHVfcOVs9bymN4eLSFuH7GlkPo4TijuRGX0lGB5SA33icvXcyThSbJINaW7FN2GaeYfzAGmmu4Qgc3Wt87T5toGxUcNReWlblT890yVerRVBYYdr8VwGmc__Y8ZzGZSXwXE1OeS_NsYg5uNDWVhmhUsimkF4oqwnXm1QZxhoajPOvK0JWTlE9esu7-9tS0ZLkC8aPjHDmYufulOTw2iBjbrKsCywt7fVfxvmbH3T2kAFaKG-SyATYLpKA0kkC7CK5E0HxORMgQgUj0xs-9iBNV_WtMR8QiUWpg64wY3Mc7y85DYzoZ3Hd148joNemBMqo1kV7dvVKs3TDm_0uKtpjfosHUFcv1_ZPHmtN2mBD1ohjyUhwcG7OVXuUkPJKX0lqu4zEYYC404xOZ1G8Qf_d5puT6p21-apamaO0_icD-uOWows4CMElIUs1ixLs9-r5QfvakXX9ph-SmtEc4QnbDm5kUg8IkOD_kMKGwZqhPoa6wTk-QQ8StZ_Cdwtm1X2-HgAY2kGfmEPkE7dvw3mPGo6UbZNzs4dyfK-KVrlkMUoSFrbUZfQ7ppbdVCwj-OggojmNewr7bqKSfyudaFE2iPjOeLNDasKMycPhFI7476zZ47wPRVzgHRM-Uf-ay3KdVwOOp6vqsRS05mAKG9cN2RzIWwCXSosiThOpBAhxyzqae2871N1A5BUfTD2sMNjS3FoZq8ahDjdG09SAlninzDMZbbwQL4pObF9YBXF9wNVdWcb5zpK1l-y8m-zcIiybv_wnr1epevH8CmsVH-tSLZkWdGxp-e81O-6py0jArGhgiokhUoGSbYkIiOcV2BSuqlTZkiFJHknpdeb6TpC3BtFfX9yiZWhYaegC15SjLm19eANDQJADpdFAXUCdA8855fo0ryJJWFBmu0kfrlUCPCi6YSYhzM_KEMX5462enmREAmBinU4pvem6ckA5EirSXH4dWPweSEUAUTAvgFO3nB952Y_SDnql-BXlkZk8kqRit-xjgfplZ1qb_OqtMzqHgmoeTr5PD5YRD0C5NOP0sCeiZVYjaEFb2T4eajGUmQvdWYu1O-o9gDNpZm5AfYLFIM2ZoFA=w1526-h1416?auditContext=prefetch',
  ogType: 'website',
  date: '2025-06-18',
  tag1: '#스마트교통',
  tag2: '#스마트교통시스템',
  tag3: '#RTLS',
  tag4: '#교통안전 #도시교통솔루션',
  text: [
    {
      head: '',
      subHead: '',
      desc: '교통은 도시 생활에서 필수적인 부분이지만, 교통 체증, 사고, 환경 오염과 같은 많은 문제를 일으키기도 합니다. 이러한 문제를 해결하기 위해 스마트 교통이 등장하여 전 세계적인 추세가 되었습니다. 그렇다면 스마트 교통이란 무엇인가? 이것이 우리의 이동 방식을 어떻게 변화시키는가? 함께 알아보겠습니다!',
      dot: ''
    },
    {
      head: '스마트 교통이란 무엇인가?',
      subHead: '',
      desc: '스마트 교통 (Intelligent Transportation Systems - ITS)은 정보 기술, 통신 및 인공 지능을 교통 시스템의 관리, 운영 및 운행에 적용하는 것입니다. 스마트 교통의 주요 목표는 교통 참여자의 효율성, 안전성 및 편리성을 높이고, 환경에 미치는 부정적인 영향을 줄이는 것입니다.\n\n이 시스템은 차량 흐름 관리, 실시간 정보 제공, 대중교통 최적화 등 여러 요소를 포함합니다. 스마트 교통을 지원하는 주요 기술 중 하나는 RTLS (Real-Time Location System)로, 차량의 위치를 정확하고 즉시 추적하는 데 도움을 줍니다.',
      dot: ''
    },
    {
      head: 'RTLS란 무엇인가?',
      subHead: '',
      desc: '스마트 교통은 전 세계 여러 곳에서 성공적으로 구현되었으며, RTLS (Real-Time Location System) 기술은 이 시스템의 효율성을 높이는 데 중요한 역할을 하고 있습니다.\n\nRTLS는 Wi-Fi, RFID, GPS 또는 초음파와 같은 기술을 사용하여 물체(예: 차량, 화물)의 위치를 실시간으로 정확하게 추적하는 시스템입니다. 스마트 교통 분야에서 RTLS는 차량 관리와 운영 최적화를 더 효율적으로 만듭니다.',
      dot: ''
    },
    {
      head: '스마트 교통에서 RTLS의 응용',
      subHead: '',
      desc: '운송 차량 관리\nRTLS는 트럭, 버스 또는 택시의 정확한 위치를 추적하여 경로 조정과 대기 시간 단축을 돕습니다.\n예: 물류 회사는 RTLS를 사용하여 배송을 최적화하고 차량이 정시에 도착하도록 합니다.\n\n도시 교통 모니터링\nRTLS는 차량의 실시간 위치 데이터를 제공하여 관리 기관이 차량 흐름을 조정하고 교통 체증을 줄이는 데 도움을 줍니다.\n싱가포르에서는 RTLS가 대중교통 차량을 추적하고 일정을 유연하게 조정하는 데 사용됩니다.\n\n주차장 검색 지원\nRTLS는 운전자가 모바일 앱을 통해 빈 주차 공간을 찾을 수 있도록 도와주며, 혼잡 지역에서의 교통 체증을 줄입니다.\n예: 서울과 같은 도시에서는 스마트 주차장에 RTLS를 적용하고 있습니다.\n\n교통 안전 강화\nRTLS는 과속이나 급정거와 같은 비정상적인 차량 움직임을 감지하여 운전자와 당국에 경고를 보냅니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '실제 사례',
      desc: '싱가포르: RTLS를 통합한 교통 시스템으로 대중교통을 관리하고 ERP 자동 요금 징수로 도심 차량 유입을 제어합니다.\n\n한국: 서울의 TOPIS 시스템은 RTLS를 사용하여 버스를 추적하고 승객에게 실시간 정보를 제공합니다.\n\n미국: 로스앤젤레스는 RTLS를 사용하여 적응형 신호등과 차량 흐름을 모니터링합니다.',
      dot: ''
    },
    {
      head: '스마트 교통의 이점',
      subHead: '',
      desc: '교통 체증 감소\n차량 흐름을 유연하게 조정하여 출퇴근 시간의 교통 체증을 줄입니다.\n실시간 정보로 운전자가 혼잡한 도로를 피할 수 있도록 도와줍니다.\n\n교통 안전 강화\n운전 지원 기술과 조기 경고로 인적 오류로 인한 사고를 줄입니다.\n교통 모니터링으로 사고를 신속하게 감지하고 처리합니다.\n\n시간과 비용 절약\n더 빠르고 원활한 이동으로 시간을 절약합니다.\n최적화된 경로로 연료 비용을 줄입니다.\n\n환경 오염 감소\n원활한 교통 흐름으로 차량 배기가스를 줄입니다.\n대중교통 사용을 장려하여 개인 차량 사용을 줄입니다.\n\n삶의 질 향상\n교통 체증으로 인한 스트레스를 줄이고 더 편안한 이동 경험을 제공합니다.\n서비스와 일자리에 대한 접근성을 개선합니다.',
      dot: ''
    },
    {
      head: '결론',
      subHead: '',
      desc: '스마트 교통은 RTLS, IoT, AI, Big Data와 같은 기술의 지원을 받아 도시 교통 문제를 해결하는 실질적인 해결책입니다. 교통 체증 감소, 안전성 증가, 환경 보호에 이르기까지 스마트 교통은 지속 가능한 미래를 위한 열쇠입니다. 이러한 혁신을 지원하고 더 나은 삶의 환경을 만들기 위해 더 많이 알아보세요!',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/enterprise/construction/safety',
      },
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/enterprise/construction/asset',
      },
      {
        img: constructionEquipment.thumb,
        data: 'constructionEquipment',
        link: '/enterprise/construction/equipment',
      },
    ],
  },
};
